import { VirtualScrollWrapper } from '@shared/components/VirtualScroll';
import { applyScrollBarStyles } from '@shared/utils/styles';
import { pxToRem } from '@withjoy/joykit/theme';
import { Flex, styled } from '@withjoy/joykit';

export const SCROLL_BAR_WIDTH = 6;
// Used with Virtual List Items
export const VirtualScrollableArea = styled(VirtualScrollWrapper)<{ transparentScrollbar?: boolean }>`
  ${applyScrollBarStyles};
  ::-webkit-scrollbar {
    width: ${pxToRem(SCROLL_BAR_WIDTH)};
  }
  ::-webkit-scrollbar-thumb:vertical {
    border-right: ${SCROLL_BAR_WIDTH}px solid ${props => (props.transparentScrollbar ? 'transparent' : '#eaeaea')};
  }
`;
// Used without Virtual List Items
export const ScrollableArea = styled(Flex)<{ transparentScrollbar?: boolean }>`
  ${applyScrollBarStyles};
  ::-webkit-scrollbar {
    width: ${pxToRem(SCROLL_BAR_WIDTH)};
  }
  ::-webkit-scrollbar-thumb:vertical {
    border-right: ${SCROLL_BAR_WIDTH}px solid ${props => (props.transparentScrollbar ? 'transparent' : '#eaeaea')};
  }
`;
